/*
 * @Author: Merlin
 * @Date: 2024-02-19 15:27:15
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-04 16:00:22
 * @Description: 
 */
import step01 from '../img/rules/rule01.png';
import step02 from '../img/rules/rule02.png';
import step03 from '../img/rules/rule03.png';
import step04 from '../img/rules/rule04.png';
import mobile_step01 from '../img/rules/mobile_rule01.png';
import mobile_step02 from '../img/rules/mobile_rule02.png';
import mobile_step03 from '../img/rules/mobile_rule03.png';
import mobile_step04 from '../img/rules/mobile_rule04.png';

export const aMinesRule = [{
    content1: 'mines.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: mobile_step01,
},{
    content1: 'mines.ruleDesc02',
    constent2: '',
    img: step02,
    imgMobile: mobile_step02,
},{
    content1: 'mines.ruleDesc03',
    constent2: '',
    img: step03,
    imgMobile: mobile_step03,
},{
    content1: 'mines.ruleDesc04',
    constent2: '',
    img: step04,
    imgMobile: mobile_step04,
},];




